import type { ReactNode } from 'react'

export function PlatformShowcase({ eyebrow, title }: { eyebrow?: ReactNode; title: ReactNode }) {
  return (
    <>
      <p className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white/85 ring-1 ring-white/20 backdrop-blur">
        <span className="size-1.5 rounded-full bg-emerald-400" />
        {eyebrow ?? 'Business management for India'}
      </p>
      <h2 className="mt-4 text-4xl leading-[1.08] font-semibold tracking-tight text-balance xl:text-[2.75rem]">
        {title}
      </h2>
    </>
  )
}
